module.exports = __webpack_public_path__ + "static/media/entrance.7040381f.jpg";